import React, { useEffect, useState } from "react";

import { useDispatch,useSelector } from "react-redux";
import { Memberlist } from "../../apis/api/MembershipApi";
import Cookies from "js-cookie";
import MembershipPlan from "./MembershipPlan";

const Membership = () => {
    const dispatch=useDispatch();
  const[data, setData] = useState();
  const bgClasses = ["bg-danger", "bg-primary", "bg-warning"];
 
  const company_id=Cookies.get("company_id")

  const {membership_list} = useSelector((state) => state.MembershipSlice);
  
  useEffect(() => {
    dispatch(Memberlist({ company_id: company_id }));
}, [dispatch, company_id]);


useEffect(() => {
    setData(membership_list.data);
}, [membership_list]);


return (
  <div className="row row-cols-1 row-cols-lg-3">
    {data?.map((plan, index) => {
      const bgClass = bgClasses[index % bgClasses.length]; // Alternate background class
      return <MembershipPlan key={plan.id} plan={plan} index={index} bgClass={bgClass} />;
    })}
  </div>
);
}

export default Membership;
